<div *ngIf="isEnvelop" style="display: inline; align-items: flex-start; width: 100%" data-cy="front-desk-filters-envelope-container">
  <mat-grid-list cols="3" rowHeight="25px" class="grid-list-container" data-cy="front-desk-filters-envelope-grid">
    <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-for-header">
      <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="front-desk-filters-envelope-for-title">Envelop For</p>
    </mat-grid-tile>
    <mat-radio-group aria-label="Report For" data-cy="front-desk-filters-envelope-for-group">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-patient-container">
        <mat-radio-button value=Patient [checked]="true" (change)="radioChange($event)" data-cy="front-desk-filters-envelope-patient-radio">Patient</mat-radio-button>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-patient-spacer">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-contact-container">
        <mat-radio-button value=Contact (change)="radioChange($event)" style="margin-left: 5px" data-cy="front-desk-filters-envelope-contact-radio">Contact</mat-radio-button>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-contact-dropdown-container">
        <div *ngIf="envelopFor==='Contact'" style="flex: 1;" data-cy="front-desk-filters-envelope-contact-dropdown-wrapper">
            <app-tdo-dropdown
                              [dataSource]="PatientContactsList"
                              dataSourceDisplayKey="FirstName"
                              [isObjectValue]="true"
                              [value]="selectedContact"
                              (selectionChange)="onChangeContact($event)"
                              data-cy="front-desk-filters-envelope-contact-dropdown">
            </app-tdo-dropdown><!--placeholder="Contact"!-->
        </div>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-doctor-container">
        <mat-radio-button value=Referring (change)="radioChange($event)" style="margin-left: 5px" data-cy="front-desk-filters-envelope-doctor-radio">Doctor</mat-radio-button>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-doctor-select-container">
        <div *ngIf="envelopFor==='Referring'" style="flex: 1;" data-cy="front-desk-filters-envelope-doctor-select-wrapper">
          <mat-form-field floatLabel="auto" style="width: 100%; background-color: white; border-radius: 8px;" data-cy="front-desk-filters-envelope-doctor-form-field">
            <!--<mat-label>Referring Doctor</mat-label>!-->
            <mat-select [formControl]="referringSelected" [errorStateMatcher]="matcher" data-cy="front-desk-filters-envelope-doctor-select">
              <mat-option (onSelectionChange)="onChangeReferringDoctor($event)" *ngFor="let doctor of ReferringDoctorList" [value]="doctor" [attr.data-cy]="'front-desk-filters-envelope-doctor-option-' + doctor.LastName.toLowerCase()">
                {{doctor.FirstName}} {{doctor.LastName}}
              </mat-option>
              <!--<mat-error *ngIf="referringSelected.hasError('required')">You must make a selection</mat-error>!-->
            </mat-select>
          </mat-form-field>
        </div>
          </mat-grid-tile>
    </mat-radio-group>
    <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-size-header">
      <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="front-desk-filters-envelope-size-title">Envelop Size</p>
    </mat-grid-tile>
    <mat-radio-group data-cy="front-desk-filters-envelope-size-group">
    <mat-grid-tile [colspan]="3" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-regular-container">
      <mat-radio-button value=Regular [checked]="true" (change)="radioSizeChange($event)" style="margin-right: auto; margin-left: 10px" data-cy="front-desk-filters-envelope-regular-radio">Regular 5 x 9</mat-radio-button>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="3" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-large-container">
      <mat-radio-button value=Large (change)="radioSizeChange($event)" style="margin-right: auto; margin-left: 10px" data-cy="front-desk-filters-envelope-large-radio">Large 9 x 12</mat-radio-button>
    </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="2" class="mat-grid-tile-container" data-cy="front-desk-filters-envelope-number10-container">
        <mat-radio-button value=Number10 (change)="radioSizeChange($event)" style="margin-right: auto; margin-left: 10px" data-cy="front-desk-filters-envelope-number10-radio">Envelope #10</mat-radio-button>
      </mat-grid-tile>
    </mat-radio-group>
  </mat-grid-list>
</div>
<!--<div *ngIf="isEnvelop" style="display: inline-block; align-items: flex-start; width: 100%">
  <div style="float:left">
    <span>Envelop Size</span>
  </div>
  <div style="margin-top: 40px">
    <div style="width: 30%; float:left">
      <mat-radio-group>
        <mat-radio-button value=Regular [checked]="true" (change)="radioSizeChange($event)">Regular 5 x 9</mat-radio-button>
        <mat-radio-button value=Large (change)="radioSizeChange($event)">Large 9 x 12</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>!-->
<div *ngIf="isTreatmentPlan" style="display: inline-block; align-items: flex-start; width: 100%" data-cy="front-desk-filters-treatment-plan-container">
  <div style="float:left" data-cy="front-desk-filters-treatment-plan-header">
    <span data-cy="front-desk-filters-treatment-plan-label">Treatment Plan</span>
  </div>
  <div style="margin-top: 40px;width:100%" data-cy="front-desk-filters-treatment-plan-dropdown-container">
    <div style="float: left;width:100%" data-cy="front-desk-filters-treatment-plan-dropdown-wrapper">
      <app-tdo-dropdown placeholder="Select Treatment Plan"
                        [dataSource]="listOfParentTreatmentPlans"
                        dataSourceDisplayKey="Description"
                        [isObjectValue]="true"
                        [value]="selectedParentTreatmentPlan"
                        (selectionChange)="onSelectedTreatmentPlanChange($event)"
                        data-cy="front-desk-filters-treatment-plan-dropdown">
      </app-tdo-dropdown>
    </div>
  </div>
  <div style="float:left" data-cy="front-desk-filters-option-plan-header">
    <span data-cy="front-desk-filters-option-plan-label">Option Plan</span>
  </div>
  <div style="margin-top: 40px;width:100%" data-cy="front-desk-filters-option-plan-dropdown-container">
    <div style="float: left;width:100%" data-cy="front-desk-filters-option-plan-dropdown-wrapper">
      <app-tdo-dropdown placeholder="Select Option Plan"
                        [dataSource]="listOfOptionTreatmentPlans"
                        dataSourceDisplayKey="Description"
                        [isObjectValue]="true"
                        [value]="selectedOptionTreatmentPlan"
                        (selectionChange)="onSelectedTreatmentOptionPlanChange($event)"
                        data-cy="front-desk-filters-option-plan-dropdown">
      </app-tdo-dropdown>
    </div>
  </div>
</div>
